class PageLayoutCollection extends App.Collections.BaseCollection {
    model = App.Models.PageLayout;

    action = "index";
    service = "";

    url = () => (`form/${this.service}/${this.action}`);

    setAction = (action) => {
        this.action = action;
    }

    setService = (service) => {
        this.service = service;
    }

    getSectionRelatedList = () => {
        const length = this.size();

        // em todos os resultados
        for (let i = 0; i < length; i++) {
            const sections = this.at(i).get("sections");

            // em todas as sessões
            for (let x = 0; x < sections.length; x++) {
                const sectionLists = sections[x].sectionRelatedLists;

                // só vai se tiver related list, evita iterar nas outras sessões
                if (sectionLists.length > 0) {
                    const searchGridColumns = sectionLists[0].searchGridLayout.searchGridColumns.sort((a, b) => a.columnOrder - b.columnOrder);
                    return searchGridColumns;
                }
            }
        }
    }

    getSearchGridLayoutId = () => {
        const length = this.size();

        // em todos os resultados
        for (let i = 0; i < length; i++) {
            const sections = this.at(i).get("sections");

            // em todas as sessões
            for (let j = 0; j < sections.length; j++) {
                const sectionLists = sections[j].sectionRelatedLists;

                // só vai se tiver related list, evita iterar nas outras sessões
                if (sectionLists.length > 0) {
                    return sectionLists[0].searchGridLayout.id;
                }
            }
        }
    }

    /*
     * Faz um parse nos sectionFieldLayouts objeto de pageLayout e devolve um
     * array com todos os Fields.
     */

    getFieldsFormFormLayout = () => {
        const fields = [];

        this.models.forEach(model => {
            const sections = model.get("sections");
            if (typeof (sections) !== "undefined") {
                for (let x = 0; x < sections.length; x++) {
                    for (let a = 0; a < sections[x].sectionFields.length; a++) {
                        fields.push(sections[x].sectionFields[a].field);
                    }
                }
            }
        });
        return fields;
    }

    /*
     * Retorna a lista de fields de um layout de um grid em um array.
     * 
     */
    getGridLayoutFieldList = () => {
        const columns = this.getSectionRelatedList();
        const fieldList = [];

        if (typeof (columns) !== "undefined") {
            for (let i = 0; i < columns.length; i++) {
                fieldList.push(columns[i]);
            }
            return fieldList;
        }
        return false;
    }

    createDataMapper = (entity) => {
        if (typeof (App.Forms[entity]) === "undefined") {
            App.Forms[entity] = {};
            App.Forms[entity].dataMapper = {};
        } else {
            App.Forms[entity].dataMapper = {};
        }

        const columns = this.getFieldsFormFormLayout();

        for (let i = 0; i < columns.length; i++) {
            const fieldMap = {
                "lookupEntity": columns[i].lookupEntity.key,
                "lookupEntityColumn": columns[i].lookupEntityColumn,
                "type": columns[i].type
            };

            App.Forms[entity].dataMapper[columns[i].name] = fieldMap;
        }
    }
}

App.Collections.PageLayout = PageLayoutCollection;
